<script lang="ts">
    export let data: NavElement[]
    export let menuclass: string = null
    export let level: number
    export let depth: number = 1
    export let navopen: boolean

    let menu_open = "none"

    const triggerMenu = (which: string) => {
        menu_open = which ?? "none"
    }
</script>

<ul class="{menuclass ? menuclass : ''}">
    {#each data as item, idx}
        <li
            class:haschildren="{!!item.elemente?.length}"
            class:active="{menu_open == 'menu_' + idx}"
        >
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <span class="arrow" on:click="{() => triggerMenu('menu_' + idx)}"
                ><img src="/media/arrow_down.svg" alt="" /></span
            >
            <a
                target="{item.newtab ? '_blank' : ''}"
                href="{item.link}"
                on:click="{() => {
                    navopen = false
                }}"
            >
                {#if item.icon}
                    <span class="icon"
                        ><img src="{item.icon}" alt="{item.name}" /></span
                    >
                {/if}
                <span class="text">{item.name}</span>
            </a>

            {#if item.elemente?.length && level < depth}
                <svelte:self
                    data="{item.elemente}"
                    level="{level + 1}"
                    depth="{depth}"
                    bind:navopen
                />
            {/if}
        </li>
    {/each}
</ul>
